
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAPartnerMixin, PartnersRoutingMixin, VuetifyMixin } from '@/mixins';
import { userStore } from '@/store';

@Component
export default class PartnerProduct extends Mixins(VuetifyMixin, BAPartnerMixin, PartnersRoutingMixin) {
    @Prop({required: true}) partnerName: string;
    @Prop({required: true}) partnerId: string;

    mounted() {
        if( this.$route.path.includes('public') ) {
            if( userStore.IsReady ) {
                this.gotoRoute(this.RouteToPartnerProduct(this.partnerName, this.partnerId));
                return;
            }
        }
    }
}

